export const LOCAL_MIC_AUDIO_ACTIVITY_EVENT = "local_mic_audio_activity";
export const LOCAL_MIC_AUDIO_ACTIVITY_VOLUME_THRESHOLD = 0.00001;
export const LOCAL_MIC_AUDIO_ACTIVITY_RESET_THROTTLE_MS = 15 * 1000;

export function shouldEmitLocalMicAudioActivity({
  isMicEnabled,
  volume,
  now = Date.now(),
  lastEmittedAt = 0,
  threshold = LOCAL_MIC_AUDIO_ACTIVITY_VOLUME_THRESHOLD,
  throttleMs = LOCAL_MIC_AUDIO_ACTIVITY_RESET_THROTTLE_MS
} = {}) {
  return Boolean(isMicEnabled && volume > threshold && (!lastEmittedAt || now - lastEmittedAt >= throttleMs));
}
